import { BrowserRouter, Routes, Route } from 'react-router-dom';

import OpcoesDeAcesso from './screens/OpcoesDeAcesso';
import Login from './screens/Login';


import DriveIT from './screens/search-screens/DriveIT';
import Reflex from './screens/search-screens/Reflex';


import DriveITEditarequipamentos from './screens/edit-screens/DriveIT_EditarEquipamentos';
import ReflexEditarequipamentos from './screens/edit-screens/Reflex_EditarEquipamentos';
import PerfisDeUsuario from './screens/edit-screens/PerfisDeUsuario';

import DriveIT_CriarEquipamentos from './screens/creation-screens/DriveIT_CriarEquipamentos';
import Reflex_CriarEquipamentos from './screens/creation-screens/Reflex_CriarEquipamentos';

//rotas
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<Login />} ></Route>
            <Route path='/OpcoesDeAcesso' element={<OpcoesDeAcesso />}>Opcoes de Opcoes</Route>
            <Route path='/DriveIT' element={<DriveIT />} />
            <Route path='/Reflex' element={<Reflex />} />
            {/* telas admin */}
            <Route path='/DriveITEditarequipamentos' element={<DriveITEditarequipamentos />} />
            <Route path='/ReflexEditarequipamentos' element={<ReflexEditarequipamentos />} />
            <Route path='/PerfisDeUsuario' element={<PerfisDeUsuario />} />
            <Route path='/DriveIT_CriarEquipamentos' element={<DriveIT_CriarEquipamentos />} />
            <Route path='/Reflex_CriarEquipamentos' element={<Reflex_CriarEquipamentos />} />
            
          </Routes>
        </BrowserRouter>
      </header>
    </div>
  );
}

export default App;
